import React from 'react';
import { ShieldCheck, ShieldAlert, Shield } from 'lucide-react';
import { useT } from '../../services/i18n';

const STYLE = {
  Excellent: ['bg-emerald-100 text-emerald-800 border-emerald-200', ShieldCheck, 'rel.excellent'],
  Bon: ['bg-green-50 text-green-700 border-green-200', ShieldCheck, 'rel.good'],
  Moyen: ['bg-amber-50 text-amber-800 border-amber-200', Shield, 'rel.average'],
  'À surveiller': ['bg-red-50 text-red-700 border-red-200', ShieldAlert, 'rel.watch'],
};

// Backend labels (Excellent / Bon / Moyen / À surveiller) are keys, rendered in the UI language
export const relLabelKey = (label) => (STYLE[label] || STYLE.Moyen)[2];

// 0–100 reliability score (40 % confirmation, 35 % answer delay, 25 % reassignments suffered)
const ReliabilityBadge = ({ reliability: r, testId, detailed = false }) => {
  const { t } = useT();
  if (!r) return <span className="text-[11px] text-gray-400" data-testid={testId}>{t('rel.noData')}</span>;
  const [cls, Icon, key] = STYLE[r.label] || STYLE.Moyen;
  const tip = t('rel.tip', { c: r.components.confirmation, d: r.components.delay, r: r.reassigned_away, rs: r.components.reassign, n: r.sample });
  return (
    <span className="inline-flex flex-col items-end gap-0.5" data-testid={testId} title={tip}>
      <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-semibold ${cls}`}><Icon size={11} /> {r.score}/100 · {t(key)}</span>
      {detailed && <span className="text-[10px] text-gray-500">{t('rel.detail', { c: Math.round(r.components.confirmation), d: Math.round(r.components.delay), r: r.reassigned_away })}</span>}
    </span>
  );
};

export default ReliabilityBadge;
